<template>
    <!-- 我的订单 -->
    <div class="customer_box">
        <div class="customer_search_box">
            <div class="search-item">
                <span>关键字</span>
                <el-input style="width: 190px;" clearable placeholder="订单编号、商品名称" size="small" v-model="filterinfo.search"></el-input>
            </div>
            <div class="search-item">
                <span>下单日期</span>
                <el-date-picker style="width: 200px;" v-model="timeRange" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="btn_box">

                <el-button v-if="tabIndex==6" class="btn_item" type="primary" size="small" @click="getReturnList(1)">查询</el-button>
                <el-button v-else-if="tabIndex==99" class="btn_item" type="primary" size="small" @click="getMultipleList(1)">查询</el-button>
                <el-button v-else class="btn_item" type="primary" size="small" @click="getCustomerList(1)">查询</el-button>
                <el-button class="btn_item" size="small" @click="resetClick">重置</el-button>
            </div>
        </div>
        <div class="tab_box">
            <span class="tab_item" :class="{active: tabIndex == item.id}" @click="tabClick(item.id)" v-for="(item,index) in tabList" :key="index">{{item.title}}</span>
        </div>
        <div class="list_box" v-if="tableData.length&&tabIndex!=99">
            <div class="list_item" v-for="(item,index) in tableData" :key="index">
                <div class="item_top">
                    <div>
                        <span v-if="tabIndex!=6">订单编号: <span style="color: #222;">{{item.orderNumber}}</span></span>
                        <span v-if="tabIndex==6">订单编号: <span style="color: #222;">{{item.returnNumber}}</span></span>
                        <span v-if="tabIndex!=6" class="copy" @click="copyOrder(item.orderNumber)">复制</span>
                        <span v-if="tabIndex==6" class="copy" @click="copyOrder(item.returnNumber)">复制</span>
                    </div>
                    <span v-if="tabIndex!=6">下单时间: <span style="color: #222;">{{item.postDate}}</span></span>
                    <span v-if="tabIndex==6">下单时间: <span style="color: #222;">{{item.createdTime}}</span></span>
                </div>
                <div class="item_center">
                    <div class="goods_box">
                        <div class="goods_list">
                            <img class="goods_item" v-for="(items,indexs) in item.imgs" :key="indexs" :src="items" alt="">
                        </div>
                    </div>
                    <div class="item_right_box">
                        <div class="item_right">
                            <span>{{item.status }}</span>
                            <span @click="viewDetail(item.orderNumber)" v-if="tabIndex!=6">查看订单详情</span>
                            <span @click="viewReturnDetail(item.returnNumber)" v-if="tabIndex==6">查看订单详情</span>
                        </div>
                    </div>
                </div>
                <div class="item_bottom">
                    <div>共<span style="color: #F92B2B;font-weight:600;">{{item.goodsNum}}</span>个商品<span style="display: inline-block;width: 12px;"></span>合计：<span style="color: #F92B2B;">￥<span v-if="tabIndex!=6" style="font-size: 20px;font-weight:600;">{{item.paid}}</span><span v-if="tabIndex==6" style="font-size: 20px;font-weight:600;">{{item.price}}</span></span></div>
                    <div class="btn_box">
                        <div class="btn_item" v-if="tabIndex!=6" @click="exportOrder(item.orderNumber)">导出Excel</div>
                        <div class="btn_item" v-if="tabIndex!=6&&(item.status=='待收货'||item.status=='已完成')" @click="invoiceClick(item.orderNumber)">查看发票</div>
                        <div class="btn_item" v-if="tabIndex!=6" @click="againBuy(item.orderNumber)">再次购买</div>
                        <div class="btn_item" v-if="tabIndex!=6&&(item.status=='待收货'||item.status=='已完成')" @click="deliveryClick(item.orderNumber)">查看物流</div>
                        <div class="btn_item" v-if="tabIndex!=6&&(item.status=='待收货'||item.status=='已完成')" @click="outClick(item.orderNumber)">出库发货单</div>

                        <el-popconfirm title="为了保证您的售后权益，请收到商品确认无误后再确定收货" @onConfirm="suerClick(item.orderNumber)" v-if="tabIndex!=6&&item.status!='已完成'&&item.status=='待收货'">
                            <div class="btn_item" slot="reference" v-if="tabIndex!=6&&item.status!='已完成'&&item.status=='待收货'">确认收货</div>
                            <!-- <div class="btn_item" slot="reference" v-if="scope.row.statusTitle=='审核通过'">设为默认</div> -->
                        </el-popconfirm>

                        <el-popconfirm title="取消后无法恢复，优惠券可退回，有效期内使用" @onConfirm="cancelCilck(item.orderNumber)" v-if="tabIndex!=6&&item.status=='待付款'">
                            <div class="btn_item" v-if="tabIndex!=6&&item.status=='待付款'" slot="reference">取消订单</div>
                            <!-- <div class="btn_item" slot="reference" v-if="scope.row.statusTitle=='审核通过'">设为默认</div> -->
                        </el-popconfirm>
                        <div class="btn_item active" v-if="tabIndex!=6&&item.status=='待付款'" @click="goPay(item)">去支付</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_box" v-else-if="tableData.length&&tabIndex==99">
            <div class="list_item" v-for="(item,index) in tableData" :key="index">
                <div class="item_top" style="border:none;margin:0; ">
                    <div>
                        <el-checkbox v-model="item.checked" @change="storeChecked(item,$event)">多店订单编号：</el-checkbox>
                        <span> <span @click="viewMulDetail(item.mainOrderNumber)" style="color: #1a9dff;cursor: pointer;">{{item.mainOrderNumber}}</span></span>
                        <span class="copy" @click="copyOrder(item.mainOrderNumber)">复制</span>
                    </div>
                </div>

                <div class="item_center" style="align-items: center;height:90px;" v-for="(items,indexs) in item.ordersList" :key="indexs">
                    <div style="border-bottom: 1px solid #f7f7f7;align-items: center;height:90px;display:flex; justify-content: space-between;padding-bottom: 10px;width:100%;">
                        <div class="item_top" style="border:none;">
                            <div>
                                <div style="margin-bottom:5px;">
                                    <el-checkbox v-model="items.checked" @change="singleChecked(item,$event)">{{items.customerName}}</el-checkbox>
                                    <!-- <span style="margin-left:20px;">支付方式:</span>
                                <span style="margin-left:20px;" class="payType">微信支付</span>
                                <span style="margin-left:20px;" class="payType">支付宝支付</span> -->

                                </div>
                                <div style="margin-bottom:5px;"> <span>订单编号: <span style="color: #222;">{{items.orderNumber}}</span></span>
                                    <span class="copy" @click="copyOrder(items.orderNumber)">复制</span>
                                </div>
                                <div style="margin-bottom:5px;">
                                    <div style="display:flex;align-items:center;flex:1;text-align:center;">
                                        <div style="font-size: 16px;margin-right:20px;"><span style="vertical-align: middle;">商品总件数：</span><span style="color:#F92B2B;font-weight: 600;vertical-align: middle;">{{items.kindNum }}</span></div>
                                        <div style="font-size: 16px;margin-right:20px;">
                                            <span style="vertical-align: middle;">优惠金额：</span><span style="font-weight: 600;color:#F92B2B;vertical-align: middle;">￥{{items.preferPrice.toFixed(2)}}</span>
                                        </div>
                                        <div style="font-size: 16px;"><span style="vertical-align: middle;">应付金额：</span><span style="font-size: 16px;color: #F92B2B;font-weight: 600;vertical-align: middle;">￥{{items.realPrice.toFixed(2)}}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item_right_box" style="height:90px;">
                            <div class="item_right">
                                <span>{{items.status }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item_bottom">
                    <div>
                        共<span style="color: #F92B2B;font-weight:600;">{{item.total}}</span>
                        个商品<span style="display: inline-block;width: 12px;"></span>
                        合计：<span style="color: #F92B2B;">￥
                            <span style="font-size: 20px;font-weight:600;">{{item.realPrice.toFixed(2)}}</span>
                            <!-- <span v-if="tabIndex==6" style="font-size: 20px;font-weight:600;">{{item.price}}</span> -->
                        </span>
                        优惠：<span style="color: #F92B2B;">￥
                            <span style="font-size: 20px;font-weight:600;">{{item.preferPrice.toFixed(2)}}</span>
                            <!-- <span v-if="tabIndex==6" style="font-size: 20px;font-weight:600;">{{item.price}}</span> -->
                        </span>
                        <!-- <span v-if="item.extra">，包含运费{{item.extra}}元</span> -->
                    </div>
                    <div class="btn_box">
                        <!-- <div class="btn_item"  @click="exportOrder(items.orderNumber)">导出Excel</div>
                        <div class="btn_item" v-if="(items.status=='待收货'||items.status=='已完成')" @click="invoiceClick(items.orderNumber)">查看发票</div> -->
                        <div class="btn_item" @click="againBuyMultiple(item)">再次购买</div>
                        <!-- <div class="btn_item" v-if="(items.status=='待收货'||items.status=='已完成')" @click="deliveryClick(items.orderNumber)">查看物流</div>
                        <div class="btn_item" v-if="(items.status=='待收货'||items.status=='已完成')" @click="outClick(items.orderNumber)">出库发货单</div>

                        <el-popconfirm title="为了保证您的售后权益，请收到商品确认无误后再确定收货" @onConfirm="suerClick(items.orderNumber)" v-if="items.status!='已完成'&&items.status=='待收货'">
                            <div class="btn_item" slot="reference" v-if="items.status!='已完成'&&items.status=='待收货'">确认收货</div>
                           
                        </el-popconfirm> -->

                        <el-popconfirm title="取消后无法恢复，优惠券可退回，有效期内使用" @onConfirm="cancelCilckMultiple(item)">
                            <div class="btn_item" slot="reference">取消订单</div>

                        </el-popconfirm>
                        <div class="btn_item active" @click="goPayMultiple(item)">去支付</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div slot="empty" class="nodata_box">
                <img src="@/assets/images/index/nodata.png" />
                <span class="txt">暂无数据哦~</span>
            </div>
        </div>
        <div class="pagination_box" v-if="tableData.length">
            <el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[10, 20, 30, 40]" :page-size.sync="filterinfo.pageSize" :current-page.sync="filterinfo.page" :total="total" @current-change="getCustomerList" @size-change="getCustomerList(1)">
            </el-pagination>
        </div>
        <!-- 物流信息弹窗 -->
        <el-dialog class="dialog_box" title="查看物流" :visible.sync="logisticDialog" width="470px" center>
            <div class="dialog_main">
                <div v-if="deliveryList.length">
                    <div class="delivery_item" :class="{active: deliveryList.length>1}" v-for="(item,index) in deliveryList" :key="index">
                        <div class="item_show" v-if="!item.showDetail&&deliveryList.length>1">
                            <span>{{item.expressCompany}}：{{item.waybillNumber}}</span>
                            <span @click="deliveryDetail(item)">查看详情</span>
                        </div>
                        <div class="item_detail" :class="{active: deliveryList.length>1}" v-else>
                            <div class="title">{{item.expressCompany}}：{{item.waybillNumber}}</div>
                            <div class="node_box">
                                <el-timeline>
                                    <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size" :timestamp="activity.acceptTime">
                                        {{activity.acceptStation}}
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                            <div class="btn" @click="item.showDetail = false" v-if="deliveryList.length>1">收起<i class="el-icon-arrow-up icon"></i></div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    暂无物流信息
                </div>
            </div>
        </el-dialog>
        <!-- 发票弹窗 -->
        <el-dialog class="dialog_box" title="查看发票" :visible.sync="invoiceDialog" width="470px" center>
            <div class="dialog_main">
                <div class="delivery_item" :class="{active: invoiceList.length>1}" v-for="(item,index) in invoiceList" :key="index">
                    <div class="item_show">
                        <span>{{item.deliveryOrderNumber}}</span>
                        <span @click="invoiceDetail(item.invoiceUrl)">查看详情</span>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 出库弹窗 -->
        <el-dialog class="dialog_box" title="出库发货单" :visible.sync="outOrderDialog" width="470px" center>
            <div class="dialog_main">
                <div class="delivery_item" :class="{active: outOrderList.length>1}" v-for="(item,index) in outOrderList" :key="index">
                    <div class="item_show">
                        <span>{{item.deliveryOrderNumber}}</span>
                        <span @click="outOrderDetail(item.deliveryOrderNumber)">查看详情</span>
                    </div>
                </div>
            </div>
        </el-dialog>
        <priceDialog v-if="tipVisible" @tipClose="tipClose" @closePriceDialog="noBuy" :priceList="tipList" :tipVisible="tipVisible"></priceDialog>
    </div>
</template>

<script>
import { getCarNum } from '@/utils/carNumber'
import {  downloadExcel } from '@/utils/common'
import priceDialog from '@/views/shopCar/component/priceDialog.vue'
export default {
    name: 'MyOrder',
    components: {
        priceDialog
    },
    data() {
        return {
            loading: false,
            logisticDialog: false,
            invoiceDialog: false,
            outOrderDialog: false,
            total: 0,
            timeRange: [],
            filterinfo: {
                page: 1,
                pageSize: 10,
                search: '',
                timeRange: '',
                state: 0,
            },
            tabIndex: 0,
            deliveryList: [],
            invoiceList: [],
            outOrderList: [],
            activities: [],
            tabList: [],
            tableData: [],
            tipList: [],//
            tipVisible: false,
        };
    },
    created() {

    },
    mounted() {
        this.getCustomerList()
        this.getTab()
    },
    beforeDestroy() {
        // 取消事件监听器
        this.tipVisible = false
    },
    methods: {
        // 点击重置
        resetClick() {
            this.filterinfo = {
                page: 1,
                pageSize: 10,
                search: '',
                timeRange: '',
                state: this.tabIndex,
            }
            this.timeRange = []
            if (this.tabIndex == 6) {
                this.getReturnList()

            } else if (this.tabIndex == 99) {
                this.getMultipleList()
            }
            else {
                this.getCustomerList()
            }
        },
        tipClose() {
            this.tipVisible = false
        },
        noBuy() {
            this.tipVisible = false
        },
        storeChecked(item, val) {
            console.log(item, val);

            item.ordersList.forEach(item => {
                item.checked = val
            })

        },
        singleChecked(item, val) {
            item.checked = item.ordersList.some(item => {
                return item.checked
            })




        },
        async suerClick(orderNumber) {
            const res = await this.$api.confirmReceipt({ orderNumber })
            if (res.status == 200) {
                this.$message.success('确认收货成功')
                this.getCustomerList()
            }
        },
        async cancelCilck(orderNumber) {
            const res = await this.$api.cancelOrder({ orderNumber })
            if (res.status == 200) {
                this.$message.success('取消订单成功')
                this.getCustomerList()
            }
        },
        async cancelCilckMultiple(item) {
            console.log(item);
            const ordersList = item.ordersList.filter(item => item.checked)
            if (!ordersList.length) return this.$message.warning('请选择要取消的订单')
            const orderNumber = ordersList.map(item => item.orderNumber)
            const res = await this.$api.multipleOrderCancel({ mainOrderNumber: item.mainOrderNumber, orderNumber })
            if (res.data.code == 200) {
                this.$message.success('取消订单成功')
                this.getMultipleList()
            }
        },
        copyOrder(text) {

            if (navigator.clipboard && window.isSecureContext) {
                // navigator clipboard 向剪贴板写文本
                navigator.clipboard.writeText(text);
                return this.$message.success('复制成功')
            } else {
                // document.execCommand('copy') 向剪贴板写文本
                let input = document.createElement('input')
                input.style.position = 'fixed'
                input.style.top = '-10000px'
                input.style.zIndex = '-999'
                document.body.appendChild(input)
                input.value = text
                input.focus()
                input.select()
                try {
                    let result = document.execCommand('copy')
                    document.body.removeChild(input)
                    if (!result || result === 'unsuccessful') {
                        this.$message.warning('复制失败')
                    } else {
                        this.$message.success('复制成功')
                    }
                } catch (e) {
                    document.body.removeChild(input)
                    alert('当前浏览器不支持复制功能，请检查更新或更换其他浏览器操作')
                }
            }


        },
        exportOrder(orderNumber) {
            this.$api.orderExport({ orderNumber }).then((res) => {
                if (res.status==200){
                  downloadExcel(res,'订单详情')
            }
                // if (res.status == 200) {
                //     // this.isLoading=false

                // }
            });
        },
        async againBuy(orderNumber) {
            const res = await this.$api.buyAgain({ orderNumber })
            if (res.data.code == 200) {
                if (res.data.data.needCheck) {
                    this.tipList = res.data.data.needSureGoods
                    this.tipVisible = true
                }
                // this.$message.success('已将订单商品加入购物车')
                this.$message({message:'已将订单商品加入购物车',type:'success',customClass:'zZindex'});
                getCarNum(this)
            }
        },
        async againBuyMultiple(item) {
            if (!item.checked) return this.$message.warning('请选择要购买的订单')
            console.log(item);
            const ordersList = item.ordersList.filter(item => item.checked)
            const orderNumber = ordersList.map(item => item.orderNumber)
            const res = await this.$api.multipleOrderAgain({ mainOrderNumber: item.mainOrderNumber, orderNumber })
            // if (res.data.code == 200) {
            //     this.$message.success('取消订单成功')
            //      this.getMultipleList()
            // }
            if (res.data.code == 200) {
                if (res.data.data.notice && res.data.data.notice.length) {
                    this.$notify({
                        title: '提示',
                        message: res.data.data.notice.join('\n') + '，其余加入购物车成功',
                        type: 'warning'
                    });
                } else {
                    this.$message.success('已将订单商品加入购物车')
                }
                // this.$message.success('已将订单商品加入购物车')
                getCarNum(this)
            }
        },
        // 切换订单类型
        async tabClick(id) {
            if (this.tabIndex == id) return
            this.tabIndex = id
            if (id == 6) {
                this.getReturnList()
            } else if (id == 99) {

                this.getMultipleList()
            }
            else {
                this.filterinfo.state = id
                this.getCustomerList()

            }
        },
        async getReturnList(num) {
            if (num == 1) {
                this.filterinfo.page = 1
            }
            let params = this.filterinfo
            if (this.timeRange && this.timeRange.length) {
                params.timeRange = this.timeRange[0] + '/' + this.timeRange[1]
            } else {
                params.timeRange = ''
            }
            this.loading = true
            const res = await this.$api.getReturnList(params)
            if (res.data.code == 200) {
                this.tableData = res.data.data.list ? res.data.data.list : []
                this.total = res.data.data.total
            }
        },
        async getMultipleList(num) {
            if (num == 1) {
                this.filterinfo.page = 1
            }
            let params = this.filterinfo
            if (this.timeRange && this.timeRange.length) {
                params.timeRange = this.timeRange[0] + '/' + this.timeRange[1]
            } else {
                params.timeRange = ''
            }
            delete params.state
            this.loading = true
            const res = await this.$api.multipleOrder(params)
            if (res.data.code == 200) {
                res.data.data.list = res.data.data.list ? res.data.data.list : []
                res.data.data.list.forEach(item => {
                    item.checked = false
                    item.total = item.ordersList.reduce((a, b) => {
                        return a + b.kindNum 
                    }, 0)
                    item.realPrice = item.ordersList.reduce((a, b) => {
                        return a + b.realPrice
                    }, 0)
                    item.preferPrice = item.ordersList.reduce((a, b) => {
                        return a + b.preferPrice
                    }, 0)
                    item.ordersList.forEach(el => {
                        el.checked = false
                    })
                })
                console.log(this.tableData);
                this.tableData = res.data.data.list
                this.total = res.data.data.total
            }
        },
        viewDetail(orderNumber) {
            this.$router.push({ 'name': 'OrderPersDetail', query: { orderNumber, from: 'now' } })
        },
        viewMulDetail(mainOrderNumber) {
            this.$router.push({ 'name': 'OrderPersDetail', query: { mainOrderNumber, from: 'now' } })
        },
        goPay(item) {
            // this.$router.push(`/pay?orderNumber=${item.orderNumber}`)
            this.$router.push(`/pay?orderNumber=${item.orderNumber}&mainOrderNumber=${item.mainOrderNumber ? item.mainOrderNumber : ''}`)
        },
        async goPayMultiple(item) {
            if (!item.checked) return this.$message.warning('请选择要购买的订单')
            const ordersList = item.ordersList.filter(item => item.checked)
            const orderNumber = ordersList.map(item => item.orderNumber)
            const res = await this.$api.multipleCanPay({ mainOrderNumber: item.mainOrderNumber, orderNumber })
            if (!res.data.data.length) {
                this.$router.push(`/pay?mainOrderNumber=${item.mainOrderNumber}&orderNumber=${orderNumber}`)
            } else {
                this.$message.warning(res.data.data.join(','))

            }
            // this.$router.push(`/pay?orderNumber=${orderNumber}`)
        },
        viewReturnDetail(orderNumber) {
            this.$router.push({ 'name': 'OrderReturnDetail', query: { orderNumber } })
        },
        async getTab() {
            const res = await this.$api.getMyOrderStatusList()

            if (res.data.code == 200) {
                this.tabList = res.data.data.filter((item) => {
                    return item.id != -1
                })
            }

        },
        // 获取列表
        getCustomerList(num) {
            if (num == 1) {
                this.filterinfo.page = 1
            }
            let params = this.filterinfo
            if (this.timeRange && this.timeRange.length) {
                params.timeRange = this.timeRange[0] + '/' + this.timeRange[1]
            } else {
                params.timeRange = ''
            }
            this.loading = true
            this.$api.getMyOrderList(params).then((res) => {
                this.loading = false
                if (res.data.code === 200) {
                    this.tableData = res.data.data.list ? res.data.data.list : []
                    this.total = res.data.data.total
                }
            });
        },
        // 查看物流按钮
        async deliveryClick(orderNumber) {
            const res = await this.$api.getDeliveryList({ orderNumber })
            if (res.data.code === 200) {
                this.deliveryList = res.data.data
                this.deliveryList.forEach(i => {
                    i.showDetail = false
                })
                if (res.data.data.length === 1) {
                    const fd = new FormData()
                    fd.append('id', res.data.data[0].id)
                    const result = await this.$api.getDeliveryDetailList(
                        fd
                    )
                    if (result.data.code == 200) {
                        if (result.data.data.length) {
                            this.activities = result.data.data
                            this.activities[0].color = '#337CFF'
                        }
                    }
                }
                this.logisticDialog = true
            }
        },
        // 查看发票按钮
        async invoiceClick(orderNumber) {
            const res = await this.$api.getInvoiceList({ orderNumber })
            if (res.data.code === 200) {
                this.invoiceList = res.data.data
                this.invoiceDialog = true
            }


        },
        // 查看出库按钮
        async outClick(orderNumber) {
            const res = await this.$api.outOrder({ orderNumber })
            if (res.data.code === 200) {
                this.outOrderList = res.data.data
                this.outOrderDialog = true
            }


        },
        // 物流弹窗查看详情
        async deliveryDetail(item) {
            // const result = await this.$api.getDeliveryDetailList({ id: item.id })
            const fd = new FormData()
            fd.append('id', item.id)
            const result = await this.$api.getDeliveryDetailList(
                fd
            )
            if (result.data.code == 200) {
                this.activities = result.data.data
                this.activities[0].color = '#337CFF'
            }
            this.deliveryList.forEach(i => {
                i.showDetail = false
            })
            item.showDetail = true
        },
        invoiceDetail(item) {
            window.location.href = item
        },
        outOrderDetail(orderNumber) {
            this.$api.downloadOutOrder({ orderNumber }).then((res) => {
                if (res.status == 200) {
                    // this.isLoading=false
                    downloadExcel(res,'出库单')
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.payType {
    display: inline-block;
    border: 1px solid #f06fa9;
    color: #be2b66;
    padding: 2px 3px;
}
.dialog_box {
    ::v-deep {
        .el-dialog {
            border-radius: 10px;
        }
        .el-dialog__header,
        .el-dialog__title {
            text-align: left;
            font-size: 20px;
            color: #1a1a1a;
            font-weight: 600;
        }
        .el-dialog__headerbtn {
            top: 24px;
        }
        .el-dialog--center .el-dialog__body {
            padding-top: 6px;
        }
    }
    .dialog_main {
        max-height: 500px;
        overflow-y: auto;
        padding-left: 20px;
        .delivery_item {
            font-weight: bold;
            font-size: 14px;
            color: #333333;

            &.active {
                background: #fafcfd;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #e6ebf5;
                margin-bottom: 9px;
            }

            .item_show {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 12px;

                span:last-of-type {
                    font-weight: 400;
                    font-size: 12px;
                    color: #337cff;
                    cursor: pointer;

                    &:hover {
                        color: #0687fe;
                    }
                }
            }

            .item_detail {
                &.active {
                    padding: 16px 20px;
                }

                .title {
                    font-size: 18px;
                    padding-bottom: 13px;
                    margin-bottom: 14px;
                    border-bottom: 1px solid #e6ebf5;
                }

                .btn {
                    font-size: 18px;
                    color: #337cff;
                    cursor: pointer;
                    text-align: center;

                    .icon {
                        font-weight: 600;
                        margin-left: 6px;
                    }

                    &:hover {
                        color: #0687fe;
                    }
                }
            }
        }
    }
}
.customer_box {
    position: relative;
    padding-top: 8px;

    .tab_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        padding: 0 22px;
        margin-bottom: 14px;
        background: #fff;

        .tab_item {
            font-size: 16px;
            color: #333333;

            &.active {
                font-weight: bold;
                color: #1a9dff;
            }
            &:hover {
                color: #1a9dff;
                cursor: pointer;
            }
        }
    }

    .list_box {
        .list_item {
            margin-bottom: 14px;
            background: #fff;

            & > div {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .item_top {
                height: 40px;
                padding: 0 31px 0 17px;
                margin-bottom: 15px;
                border-bottom: 1px solid #eeeeee;
                font-size: 14px;
                color: #666;

                .copy {
                    font-size: 13px;
                    color: #0687fe;

                    &:hover {
                        cursor: pointer;
                        color: #337cff;
                    }

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 1px;
                        height: 10px;
                        margin: 0 4px 0 7px;
                        background: #d8d8d8;
                    }
                }
            }
            .item_center {
                align-items: flex-start;

                padding-left: 16px;
                /*滚动条整体部分*/
                ::-webkit-scrollbar {
                    width: 10px;
                    height: 10px;
                }
                /*滚动条的轨道*/
                ::-webkit-scrollbar-track {
                    background-color: #f9f9f9;
                }
                /*滚动条里面的小方块，能向上向下移动*/
                ::-webkit-scrollbar-thumb {
                    background-color: #e9e9e9;
                    border-radius: 7px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background-color: #d9d9d9;
                }
                ::-webkit-scrollbar-thumb:active {
                    background-color: #c9c9c9;
                }
                .goods_box {
                    flex: 1;
                    overflow: auto;
                    padding-bottom: 8px;

                    .goods_list {
                        display: flex;
                        .goods_item {
                            width: 100px;
                            height: 100px;
                            margin-right: 10px;
                        }
                    }
                }
                .item_right_box {
                    overflow: hidden;
                    width: 130px;
                    height: 100px;
                    display: flex;
                    justify-content: flex-end;

                    .item_right {
                        width: 120px;
                        height: 100px;
                        flex-shrink: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        box-shadow: -3px 0px 6px 1px rgba(188, 188, 188, 0.16);

                        span:first-of-type {
                            margin-bottom: 8px;
                            margin-right: 10px;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                        }
                        span:last-of-type {
                            font-size: 14px;
                            color: #0687fe;
                            margin-right: 10px;

                            &:hover {
                                color: #337cff;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
            .item_bottom {
                padding: 10px 31px 15px 16px;
                font-size: 14px;
                color: #666666;

                .btn_box {
                    display: flex;
                    align-items: center;

                    .btn_item {
                        width: 86px;
                        height: 36px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: 10px;
                        border-radius: 100px 100px 100px 100px;
                        border: 1px solid #cccccc;
                        font-size: 16px;
                        color: #111111;
                        cursor: pointer;

                        &.active {
                            border-color: #0687fe;
                            color: #0687fe;

                            &:hover {
                                border-color: #337cff;
                                color: #337cff;
                            }
                        }

                        &:hover {
                            border-color: #e3e3e3;
                            color: #666666;
                        }
                    }
                }
            }
        }
    }
}

</style>
<style>
.zZindex {
    z-index:3000 !important;
  }
</style>